import { isUploadedMediaUrl } from '../utils/embedUrl';

// gloss
const SURVEY_FILE_ANSWER_KIND = 'surveyFile';

// gloss
// why: Only exact MIME subtypes with a matching server cap are offered — SVG is excluded outright
// why: as an XSS vector.
export const SURVEY_FILE_TYPE_OPTIONS = [
  { value: 'image', label: 'Images', accept: 'image/jpeg,image/png,image/gif,image/webp' },
  { value: 'video', label: 'Video', accept: 'video/mp4,video/webm,video/quicktime' },
  { value: 'pdf', label: 'PDF', accept: 'application/pdf' },
] as const;

export type SurveyFileType = (typeof SURVEY_FILE_TYPE_OPTIONS)[number]['value'];

// gloss
export const DEFAULT_SURVEY_FILE_TYPES: SurveyFileType[] = ['image', 'video', 'pdf'];

export type SurveyFileAnswer = {
  url: string;
  name: string;
  type: string;
  size: number;
};

// gloss
export const buildSurveyFileAccept = (types?: readonly SurveyFileType[] | null): string => {
  const selected = types && types.length > 0 ? types : DEFAULT_SURVEY_FILE_TYPES;
  return selected
    .map((type) => SURVEY_FILE_TYPE_OPTIONS.find((option) => option.value === type)?.accept)
    .filter((accept): accept is string => Boolean(accept))
    .join(',');
};

// gloss
export const serializeSurveyFileAnswer = (answer: SurveyFileAnswer): string =>
  JSON.stringify({ ...answer, _kind: SURVEY_FILE_ANSWER_KIND });

// gloss
export const parseSurveyFileAnswer = (answer: unknown): SurveyFileAnswer | null => {
  if (typeof answer !== 'string' || answer.length === 0) return null;
  try {
    const parsed = JSON.parse(answer) as Partial<SurveyFileAnswer> & { _kind?: unknown };
    // why: A file answer's URL must be validated as our own CloudFront host — else a tampered
    // why: answer could inject a javascript: URL.
    if (
      parsed &&
      parsed._kind === SURVEY_FILE_ANSWER_KIND &&
      typeof parsed.url === 'string' &&
      parsed.url.length > 0 &&
      isUploadedMediaUrl(parsed.url)
    ) {
      return {
        url: parsed.url,
        name: typeof parsed.name === 'string' ? parsed.name.slice(0, 256) : 'Uploaded file',
        type: typeof parsed.type === 'string' ? parsed.type : '',
        size: typeof parsed.size === 'number' ? parsed.size : 0,
      };
    }
  } catch {
    return null;
  }
  return null;
};
